
import Vue, { PropType } from 'vue';
import { CvHeader, CvHeaderName } from '@carbon/vue';
import IconTextButton from '../Buttons/IconTextButton.vue';
import ArrowLeft20 from '@carbon/icons-vue/es/arrow--left/20';

export default Vue.extend({
  name: 'WizardHeader',
  components: {
    CvHeader,
    CvHeaderName,
    IconTextButton,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
    productName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ArrowLeft20: ArrowLeft20,
    };
  },
  methods: {
    sendEvent() {
      this.$emit('header:back-button-click');
    },
  },
});
